import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import UsuarioModal from "../modal/UsuarioModal"; // Importar el modal
import "../estilos/CreateUser.css"; // Asegúrate de tener el archivo CSS correcto

const apiUrlUsers = process.env.REACT_APP_API_USERS;

const CreateUser = () => {
    const [nombre_usuario, setNombre_usuario] = useState('');
    const [password, setPassword] = useState('');
    const [roles, setRoles] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false); // Estado para controlar el modal
    const navigate = useNavigate();

    // Lista de roles estáticos
    const rol = ["administrador", "consultar_informes", "solicitar_reservas"];

    // Manejar el envío del formulario
    const store = async (e) => {
        e.preventDefault();

        // Validación de campos vacíos
        if (!nombre_usuario || !password || !roles) {
            alert('Todos los campos son obligatorios.');
            return;
        }

        try {
            // Envío de la solicitud POST
            await axios.post(apiUrlUsers, { nombre_usuario, password, roles });

            // Restablecer los campos del formulario
            setNombre_usuario('');
            setPassword('');
            setRoles('');

            // Mostrar modal de éxito
            setIsModalOpen(true);

        } catch (error) {
            console.error('Error creando el usuario:', error);
        }
    };

    // Función para cerrar el modal
    const closeModal = () => {
        setIsModalOpen(false);
        navigate('/crear_usuarios'); // Redirige después de cerrar el modal
    };

    return (
        <div className="create-user-container">
            <div className="create-user-card">
                <h2 className="create-user-title">Crear Usuario</h2>
                <form className="create-user-form" onSubmit={store}>
                    <div className="form-group">
                        <i className="icon-user"></i>
                        <input
                            type="text"
                            placeholder="Nombre de usuario"
                            value={nombre_usuario}
                            onChange={(e) => setNombre_usuario(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <i className="icon-password"></i>
                        <input
                            type="password"
                            placeholder="Contraseña"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <i className="icon-role"></i>
                        <select
                            value={roles}
                            onChange={(e) => setRoles(e.target.value)}
                        >
                            <option value="">Seleccione un rol</option>
                            {rol.map((rolItem, index) => (
                                <option key={index} value={rolItem}>
                                    {rolItem}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="form-buttons">
                        <button className="submit-button" type="submit">
                            Crear
                        </button>
                        <button
                            className="back-button"
                            type="button"
                            onClick={() => navigate(-1)}
                        >
                            Volver
                        </button>
                    </div>
                </form>
            </div>

            {/* Modal de confirmación */}
            <UsuarioModal isOpen={isModalOpen} onClose={closeModal} />
        </div>
    );
};

export default CreateUser;





